import store from '../store/index';

const modalSwitcher = (currentModal, newModal, isAutoClose) => {
    store.dispatch('modal/close', currentModal);
    setTimeout(() => {
      store.dispatch('modal/open', newModal);
    }, 200);
    if (isAutoClose) {
      setTimeout(() => {
        store.dispatch('modal/close', newModal);
      }, 1000);
    }
  };
export default modalSwitcher;
